import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pwa"
export default class extends Controller {
  connect() {
  }

  async notification(event) {
    if (window.PushManager) {
      switch (Notification.permission) {
        case 'granted':
          console.log('Permission to receive notifications has already been granted');
          break;
        case 'denied':
          console.log('Permission to receive notifications has been denied');
          break;
        default:
          const permission = await Notification.requestPermission();
          console.log(`Permission to receive notifications has been ${permission}`);
          break;
      }
    } else {
      console.log('Push notifications are not supported');
    }
  }
}
